import { render, staticRenderFns } from "./AllLomList.vue?vue&type=template&id=5bdea278"
import script from "./AllLomList.vue?vue&type=script&lang=js"
export * from "./AllLomList.vue?vue&type=script&lang=js"
import style0 from "./AllLomList.vue?vue&type=style&index=0&id=5bdea278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports